import React from 'react';
import PropTypes from 'prop-types';
import { SENSOR_STATUS_LABELS } from '../../types/lawnTypes';

/**
 * One sensor marker on the property image.
 *
 * Position comes from the sensor's `xPct`/`yPct`, so pins stay correct no matter
 * what size the yard photo renders at. Colour encodes status.
 */
export default function SensorPin({ sensor, onSelect, isSelected }) {
  const label = `${sensor.name} — ${SENSOR_STATUS_LABELS[sensor.status] || sensor.status}`;

  return (
    <button
      type="button"
      className={`lawn-pin lawn-pin-${sensor.status}${isSelected ? ' lawn-pin-selected' : ''}`}
      style={{ left: `${sensor.xPct}%`, top: `${sensor.yPct}%` }}
      onClick={(event) => {
        // Keep the click from reaching the image, which would drop a new pin.
        event.stopPropagation();
        onSelect(sensor);
      }}
      title={label}
      aria-label={label}
    >
      <span className="lawn-pin-dot" aria-hidden="true" />
      <span className="lawn-pin-label">
        {sensor.name}
        {sensor.moisturePct !== null && sensor.moisturePct !== undefined
          ? ` · ${sensor.moisturePct}%`
          : ''}
      </span>
    </button>
  );
}

SensorPin.propTypes = {
  sensor: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    xPct: PropTypes.number.isRequired,
    yPct: PropTypes.number.isRequired,
    moisturePct: PropTypes.number,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
};

SensorPin.defaultProps = {
  isSelected: false,
};
